// extracted by mini-css-extract-plugin
export default {"MailchimpIntegrations":"MailChimpIntegrations_MailchimpIntegrations__vUrTG","group":"MailChimpIntegrations_group__PxJ26","name":"MailChimpIntegrations_name__As2sa"};